import { render, staticRenderFns } from "./EtapaProgresso.vue?vue&type=template&id=317dfe7b&scoped=true"
import script from "./EtapaProgresso.vue?vue&type=script&lang=js"
export * from "./EtapaProgresso.vue?vue&type=script&lang=js"
import style0 from "./EtapaProgresso.vue?vue&type=style&index=0&id=317dfe7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317dfe7b",
  null
  
)

export default component.exports